import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { Languages, SimplifiedLanguages } from '../../../httpClient/interfaces/Languages'
import { getTempoLanguages, getTempoTerminologyLanguages } from '../../../httpClient/Requests/Api/TEMPO/system'
import { getLanguages } from '../../../httpClient/Requests/Api/XTRF/system'
import axios from 'axios'
import { LanguagesState } from '../../interfaces/LanguageState'
import { PrefixType } from '../../interfaces/Prefix'

interface Langs {
    sourceLangs: SimplifiedLanguages[]
    targetLangs: SimplifiedLanguages[]
}

export const initialState: LanguagesState = {
    sourceLangs: [],
    targetLangs: [],
    loading: false,
    error: null,
}

export const fetchLanguages = (prefix: PrefixType) =>
    createAsyncThunk(`${prefix}/languages/fetchLanguages`, async (_: void, { signal }) => {
        const source = axios.CancelToken.source()
        signal.addEventListener('abort', () => {
            source.cancel()
        })
        let languages: Langs
        if (prefix.includes('XTRF')) {
            const response = await getLanguages<Languages[]>(prefix, source.token)
            const data = response.data?.map((el) => ({
                value: el.symbol,
                label: el.displayName,
            }))
            languages = { sourceLangs: data, targetLangs: data }
        } else if (prefix === 'MEMSOURCE') {
            const { data } = await getLanguages<LanguagesState>(prefix, source.token)
            languages = data
        } else if (prefix.includes('TEMPO_TERMINOLOGY')) {
            const {
                data: { sourceLangs, targetLangs },
            } = await getTempoTerminologyLanguages<Langs>()
            languages = { sourceLangs: sourceLangs, targetLangs: targetLangs }
        } else if (prefix.includes('TEMPO')) {
            const { data } = await getTempoLanguages<SimplifiedLanguages[]>()
            languages = { sourceLangs: data, targetLangs: data } // @todo not valid for prod
        }
        return languages
    })

const languagesSlice = (prefix: PrefixType) =>
    createSlice({
        name: `${prefix}/languages`,
        initialState,
        reducers: {},
        extraReducers: (builder) => {
            builder.addCase(fetchLanguages(prefix).pending, (state) => ({ ...state, loading: true, error: null }))
            builder.addCase(fetchLanguages(prefix).fulfilled, (state, action) => {
                const { sourceLangs, targetLangs } = action.payload
                return {
                    ...state,
                    sourceLangs,
                    targetLangs,
                    loading: false,
                    error: null,
                }
            })
            builder.addCase(fetchLanguages(prefix).rejected, (state, action) => ({
                ...state,
                loading: false,
                error: action.error,
            }))
        },
    })

export const languagesActions = (prefix: PrefixType) => languagesSlice(prefix).actions

const languages = (prefix: PrefixType) => languagesSlice(prefix).reducer

export default languages
